import { render, staticRenderFns } from "./ProjectConfig.vue?vue&type=template&id=789ad1d1&scoped=true&"
import script from "./ProjectConfig.vue?vue&type=script&lang=ts&"
export * from "./ProjectConfig.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectConfig.vue?vue&type=style&index=0&id=789ad1d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789ad1d1",
  null
  
)

export default component.exports